import React from 'react';
import { faSlidersH } from '@fortawesome/pro-regular-svg-icons/faSlidersH';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function SlidersRegularIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faSlidersH} {...props} />;
}
